import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    noop as _$no,
} from 'intact';
import {makeGroupStyles} from './styles';
import {getRestProps} from '../utils';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {children, label, className} = this.get();
    const {card} = this.select.get();
    
    const classNameObj = {
        "k-select-group": true,
        [className]: className,
        [makeGroupStyles()]: true,
    }
    
    return _$cv('div', {
        ...getRestProps(this),
        'className': _$cn(classNameObj)
    }, [
        (!card) ?
            _$ce(2, 'div', (
                (
                    (_$blocks['label'] = function($super) {
                        return label;
                    }),
                    (__$blocks['label'] = function($super, data) {
                        var block = $blocks['label'];
                        var callBlock = function() {
                            return _$blocks['label'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    }),
                    __$blocks['label'](_$no)
                )
            ), 0, 'k-select-group-label') :
            undefined,
        children
    ]);
};